<template>
  <div class="img_more">
<!--    <a href="https://zhentu.71360.com/#/homePage/index" target="_blank">-->
<!--      <img class="img_design" src="@/assets/image/img_design.png">-->
<!--    </a>-->
    <div class="jump_click"
         @click="jump_url"
    >

      <img class="img_design" src="@/assets/image/img_design.png">

    </div>
  </div>
</template>

<script>
export default {
  name: 'img_more',
  methods:{
    jump_url(){
      let environment =  process.env.NODE_ENV;
      if(environment==='production'){
        window.open('https://zhentu.71360.com/#/homePage/index','_blank')
      }else{
        window.open('https://prezhentuclient.71360.com/#/homePage/index','_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.img_more {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 12px;
  background: url(~@/assets/image/moreTabBg.jpg) no-repeat;
  background-size: cover;
  .img_design {
    width: 620px;
    height: 420px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/my_img_selecter/img_more.vue